
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteG as ObiOwnShipRemoteGElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-g.js';
 
 
 

 
 export const ObiOwnShipRemoteG = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-g',
   elementClass: ObiOwnShipRemoteGElement,
   events: {
     
   }
  });
 
 